//* =-=-=-=-=-=-=-=-=-=-=-=-=-= Start of Accolade Step 1 =-=-=-=-=-=-=-=-=-=-=-=-=-= *//
const trademarks = $("#trademarkList input[type=checkbox]");
const trademarkCodes = $("#trademarkCode input[type=checkbox]");
const step1SelectedElem = $(".gs-selected");
const step1InputEem = $("input[type=search].gs-search");
const step1MessageContainer = $("#step1AutoComplete");
const step1SelectAll = $("#checkAllTrademarkBtnElem");
const step1UnselectAll = $("#unCheckAllTrademarkBtnElem");

// Define a global array to store selected item IDs
let selectedItems = [];

function updateCheckboxState(checkbox, isChecked) {
  const id = checkbox.attr("name").trim().split("_")[0];
  const label = checkbox.next().text().trim();
  const keywords = checkbox.next().next().text().trim();

  if (isChecked) {
    const trademarkObj = { id, label, keywords };
    const trademarkIndex = accolade.trademarks.findIndex((x) => x.id === id);

    if (trademarkIndex === -1) {
      accolade.trademarks.push(trademarkObj);
      accolade.quantity += 1;
      _step1PillTabUI(step1SelectedElem, id, label);

      _sanitizeTrademarksArray();
    }
    $(".step1Next").removeClass("unable");
  } else {
    const trademarkIndex = accolade.trademarks.findIndex((x) => x.id === id);

    if (trademarkIndex !== -1) {
      accolade.trademarks.splice(trademarkIndex, 1);
      accolade.quantity -= 1;
      $(`p.badge[data-id="${id}"]`).remove();
    }
    if (document.querySelectorAll(".gs-items input:checked").length === 0) {
      $(".step1Next").addClass("unable");
      $("#step2tab").addClass("unable");
    }
    // TODO: 4
    const getId = id;
    const searchHistoryIndex = accolade.searchHistory.findIndex(
      (x) => x.id === getId
    );

    if (searchHistoryIndex !== -1) {
      accolade.searchHistory.splice(searchHistoryIndex, 1);
      console.log("Unchecked by class code: ", accolade.searchHistory);
    }
  }
  // console.log(accolade);
}

function updateCheckboxes(checkboxes, isChecked) {
  checkboxes.prop("checked", isChecked);
  checkboxes.each(function () {
    updateCheckboxState($(this), isChecked);
  });
}

function _step1SingleCheck() {
  trademarks.on("change", function (event) {
    event.stopPropagation();

    const isChecked = $(this).is(":checked");
    updateCheckboxState($(this), isChecked);

    const correspondingCheckbox = trademarkCodes.filter(
      `[name="${$(this).attr("name")}"]`
    );

    correspondingCheckbox.prop("checked", isChecked);

    // TODO: 3.
    const getId = $(this).attr("data-id");
    const searchHistoryIndex = accolade.searchHistory.findIndex(
      (x) => x.id === getId
    );

    if (searchHistoryIndex !== -1) {
      accolade.searchHistory.splice(searchHistoryIndex, 1);
      console.log("User removed from unchecked: ", accolade.searchHistory);
    }

    _sanitizeTrademarksArray();
  });

  trademarkCodes.on("change", function (event) {
    event.stopPropagation();

    const isChecked = $(this).is(":checked");
    updateCheckboxState($(this), isChecked);

    const correspondingCheckbox = trademarks.filter(
      `[name="${$(this).attr("name")}"]`
    );

    correspondingCheckbox.prop("checked", isChecked);

    // Check if the item is already selected and remove appliedBackground color
    const indexToRemove = selectedItems.indexOf($(this).attr("name"));
    if (indexToRemove !== -1) {
      selectedItems.splice(indexToRemove, 1);

      _sanitizeTrademarksArray();
    }

    // Check if the item is already selected
    const listItem = step1MessageContainer.find(
      `li[data-id="${$(this).attr("name")}"].selected`
    );

    if (listItem.length > 0) {
      listItem.removeClass("selected bg-secondary text-white");
      listItem.css("pointer-events", "auto");
      listItem.find("span").css("color", "black");

      _sanitizeTrademarksArray();
    }
  });

  //* If user uncheck the checkbox also remove the pill tab
  trademarks.on("click", function (event) {
    event.stopPropagation();

    if (!$(this).is(":checked")) {
      const title = $(this).attr("data-title");
      $(`p.badge[data-id="${id}"]`).remove();
    }
  });

  trademarkCodes.on("click", function (event) {
    event.stopPropagation();

    if (!$(this).is(":checked")) {
      const id = $(this).attr("name");
      $(`p.badge[data-id="${id}"]`).remove();
    }
  });
}

function _step1CheckAllAndUncheckAll() {
  let clicked = false;

  $(step1SelectAll).click(function (event) {
    event.stopPropagation();

    $(trademarks).prop("checked", true);
    $(trademarkCodes).prop("checked", true);

    if (clicked) return;

    $(".step1Next").removeClass("unable");

    // If all checkboxes are checked, update the accolade.trademarks array and pill tabs UI
    $(trademarks).each(function () {
      const id = $(this).attr("name");
      const label = $(this).next().text().trim();
      const keywords = $(this).next().next().text().trim();

      const trademarkObj = {
        id,
        label,
        keywords,
      };

      //* First check if the trademark is already in the array
      const trademarkIndex = accolade.trademarks.findIndex((x) => x.id === id);

      if (trademarkIndex === -1) {
        accolade.trademarks.push(trademarkObj);
        accolade.quantity += 1;

        _step1PillTabUI(step1SelectedElem, id, label);
      }

      clicked = true;
    });

    // console.log(accolade);
  });

  $(step1UnselectAll).click(function (event) {
    event.stopPropagation();

    $(trademarks).prop("checked", false);
    $(trademarkCodes).prop("checked", false);

    //* If all checkboxes are unchecked, clear the accolade.trademarks array and pill tabs UI
    accolade.trademarks = [];
    accolade.quantity = 0;

    resetStateWhenClickUncheckAll();

    // TODO: 5 Clear all search history
    accolade.searchHistory = [];

    $(step1SelectedElem).find("p.badge").remove();

    $(".step1Next").addClass("unable");

    clicked = false;

    console.log("User clicked unselect all: ", accolade.searchHistory);
    // console.log(accolade);
  });
}

function _step1PillTabUI(selector, id, name) {
  // ! Remove any existing pill tabs with the same 'data-id' attribute
  $(selector).find(`p.badge[data-id="${id}"]`).remove();

  // Append the new pill tab HTML
  $(selector).each(function (index, elem) {
    const sanitizedName = name?.split("-")[1]?.trim();

    const html = `
        <p class="badge badge-info" data-id="${id}" id="gaPillTab">
            <span>${name}</span>
            <button type="button" class="close" aria-label="Close" data-id="${id}" data-title="${sanitizedName}">
                <span aria-hidden="true" data-id="${id}">×</span>
            </button>
        </p>
      `;

    $(elem).append(html);
  });

  function uncheckBytitle(dt) {
    if (
      document.querySelectorAll(`.gs-selected .close[data-title="${dt}"]`)
        .length === 1
    ) {
      document
        .querySelectorAll(`.gs-items .item input[data-title="${dt}"]`)
        .forEach((e) => {
          e.checked = false;
        });
    }
    console.log(
      "uncheckBytitle" +
        document.querySelectorAll(`.gs-selected .close[data-title="${dt}"]`)
          .length
    );
  }
  // ! Attach event handler for the "x" button to remove pill tab and uncheck checkbox
  $(selector)
    .find(`button[data-id="${id}"]`)
    .on("click", function (event) {
      event.stopPropagation();
      console.log("sktesting" + $(this).attr("data-title"));
      const dt = $(this).attr("data-title");
      uncheckBytitle(dt);
      const pillTab = $(this).closest("p.badge[data-id]");
      const checkbox = $(`#trademarkList input[type=checkbox][name="${id}"]`);
      const correspondingCheckbox = $(
        `#trademarkCode input[type=checkbox][name="${id}"]`
      );

      if (pillTab.length > 0) {
        pillTab.remove();
        checkbox.prop("checked", false);
        correspondingCheckbox.prop("checked", false);

        //* Check with selectedItems array id the item is already selected and remove appliedBackground color
        const indexToRemove = selectedItems.indexOf(id);
        if (indexToRemove !== -1) {
          selectedItems.splice(indexToRemove, 1);
        }

        //* Check if the item is already selected
        const listItem = step1MessageContainer.find(
          `li[data-id="${id}"].selected`
        );

        if (listItem.length > 0) {
          listItem.removeClass("selected bg-secondary text-white");
          listItem.css("pointer-events", "auto");
          listItem.find("span").css("color", "black");
        }

        //* Update the accolade.trademarks array
        const trademarkIndex = accolade.trademarks.findIndex(
          (x) => x.id === id
        );

        if (trademarkIndex !== -1) {
          accolade.trademarks.splice(trademarkIndex, 1);
          accolade.quantity -= 1;

          console.log(accolade);
        }

        // TODO: 2. First check with accolade.searchHistory array if the item is already in the array
        const searchHistoryIndex = accolade.searchHistory.findIndex(
          (x) => x.id === id
        );

        if (searchHistoryIndex !== -1) {
          accolade.searchHistory.splice(searchHistoryIndex, 1);
        }
      }
    });
}

function _step1SearchFilter() {
  let debounceTimer;

  function highlightMatchedWords(label, pattern) {
    return label.replace(
      pattern,
      (match) => `<span class="highlight">${match}</span>`
    );
  }

  function updateSearchResults() {
    const searchValue = $(step1InputEem).val().trim().toLowerCase();
    const searchWords = searchValue.split(/\W+/).map((word) => word.trim());
    const pattern = new RegExp(searchWords.join("|"), "gi");
    const trademarkList = $("#trademarkList");
    const matchedItems = [];

    if (searchValue === "") {
      //* If the search value is empty, clear the message container and show all checkboxes
      step1MessageContainer.empty();
      trademarkList.find("label").parent().show();
    } else {
      trademarkList.find("label").each(function () {
        const checkboxLabel = $(this).text();
        const checkLongLabel = $(this).attr("title");
        const checkboxKeywords = $(this).next().text();
        const checkbox = $(this).prev();

        const isMatches =
          checkboxLabel.toLowerCase().match(pattern) ||
          checkboxKeywords.toLowerCase().match(pattern) ||
          checkLongLabel.toLowerCase().match(pattern);

        if (isMatches) {
          checkbox.parent().show();
          const label = $(this).attr("title").trim();
          const highlightedLabel = highlightMatchedWords(label, pattern);

          //* Modify to show a portion of the keywords
          const keywords = checkboxKeywords.split(","); // Split keywords into an array
          const matchedKeywords = keywords.filter((keyword) =>
            keyword.toLowerCase().match(pattern)
          ); // Filter matched keywords

          const displayedKeywords = matchedKeywords.slice(0, 100).join(", "); // Show the first 100 matched keywords
          const highlightedKeywords = highlightMatchedWords(
            displayedKeywords,
            pattern
          ); // Highlight displayed keywords

          matchedItems.push({
            label: highlightedLabel,
            keywords: highlightedKeywords,
            id: checkbox.attr("name").trim().split("_")[0],
          });
        } else {
          checkbox.parent().hide();
        }
      });

      let autoCompletedHTML = "";

      if (matchedItems.length > 0) {
        autoCompletedHTML = matchedItems
          .map((item) => {
            const keywords = item.keywords.split(", "); // Split keywords into an array
            const keywordItems = keywords
              .map((keyword, index) => {
                const itemId = `${item.id}_${index}`; // Generate a unique identifier for each keyword item
                return `<li class="showedItems" data-id="${itemId}">
                  <strong class="found-keywords">${keyword}</strong>: - ${item.label}
                  <span class="getLabel hide">${item.label}</span>
                </li>`;
              })
              .join("");
            return keywordItems;
          })
          .join("");
      } else {
        autoCompletedHTML = "<li>No matches found</li>";
      }
      step1MessageContainer.html(autoCompletedHTML);
    }
  }

  //* Event handler for clicking on the autocomplete result
  step1MessageContainer.on("click", "li", function () {
    const listItem = $(this);
    const id = listItem.attr("data-id");
    const selectedKeyword = listItem.find(".found-keywords").text().trim();
    const label =
      selectedKeyword + " - " + listItem.find(".getLabel").text().trim();
    const checkbox = $(`#trademarkList input[type=checkbox][name="${id}"]`);

    //* Check if the checkbox is already checked
    if (checkbox.prop("checked")) return;

    //* Update the checkbox and pill tab UI
    updateCheckboxAndPillTab(id, label, true);

    //* Mark the item as selected and change the background color
    listItem.addClass("selected");
    listItem.addClass("bg-secondary text-white");

    //* Add the item to the selectedItems array
    selectedItems.push(id);

    _sanitizeTrademarksArray();

    $(".step1Next").toggleClass(
      "unable",
      step1MessageContainer.find(".showedItems.selected").length === 0
    );

    //* Hide the autocomplete container if no items are selected
    if (step1MessageContainer.find(".showedItems.selected").length === 0) {
      step1MessageContainer.hide();
    }

    // TODO: 1. Save user search type input to accolade.searchHistory
    const keywords = listItem.find(".found-keywords").text().trim();

    const searchHistoryObj = {
      label: label,
      keywords: label.split("-")[1].trim().slice(0, 3) + " - " + keywords,
      id: listItem.attr("data-id"),
    };

    //* Check if the search history is already in the array
    const searchHistoryIndex = accolade.searchHistory.findIndex(
      (x) => x.id === searchHistoryObj.id
    );

    if (searchHistoryIndex === -1) {
      accolade.searchHistory.push(searchHistoryObj);
    }
    console.log("User selected autocomplete li: ", searchHistoryObj);
  });

  //* Event handler for clicking on selected items with applied background color
  step1MessageContainer.on("click", "li.selected.bg-secondary", function () {
    const listItem = $(this);
    const label = listItem.find(".getLabel").text().trim();

    //* Show an alert indicating that the item cannot be clicked again
    new Noty({
      type: "alert",
      layout: "center",
      theme: "semanticui",
      modal: true,
      text: `"${label}" cannot be choosed again.`,
      timeout: 1500,
    }).show();
  });

  //* Event handler for checkbox changes
  $("#trademarkList input[type=checkbox]").on("change", function () {
    const checkbox = $(this);
    const id = checkbox.attr("name");
    const listItem = step1MessageContainer.find(`li[data-id="${id}"]`);

    if (!checkbox.prop("checked")) {
      //* Checkbox is unchecked, clear background color and remove from selectedItems
      listItem.removeClass("selected bg-secondary text-white");
      const indexToRemove = selectedItems.indexOf(id);
      if (indexToRemove !== -1) {
        selectedItems.splice(indexToRemove, 1);

        _sanitizeTrademarksArray();
      }
    }
  });

  //* Event handler for input changes
  $(step1InputEem).on("input", function (event) {
    event.stopPropagation();
    $("#step1AutoComplete").show();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      updateSearchResults();

      //* Clear the applied background color for selected items it there is no items has checked
      if (step1MessageContainer.find(".showedItems.selected").length === 0) {
        step1MessageContainer.find("li.selected").removeClass("selected");
        step1MessageContainer
          .find("li.bg-secondary")
          .removeClass("bg-secondary text-white");
        step1MessageContainer.find("li").css("pointer-events", "auto");
        step1MessageContainer.find("li span").css("color", "black");
      }

      applyBackgroundColorToSelectedItems();

      _sanitizeTrademarksArray();
    }, 300);
  });

  function applyBackgroundColorToSelectedItems() {
    trademarks.each(function () {
      const checkbox = $(this);
      const id = checkbox.attr("name");

      if (checkbox.prop("checked")) {
        const listItem = step1MessageContainer
          .find(`li[data-id="${id}"]`)
          .first();

        listItem.addClass("selected bg-secondary text-white");
        listItem.css("pointer-events", "none");
        listItem.find("span.highlight").removeClass("highlight");
        listItem.find("span").css("color", "yellow");

        _sanitizeTrademarksArray();
      } else {
        const listItem = step1MessageContainer
          .find(`li[data-id="${id}"]`)
          .first();

        listItem.removeClass("selected bg-secondary text-white");
        listItem.css("pointer-events", "auto");
        listItem.find("span").css("color", "black");

        _sanitizeTrademarksArray();
      }
    });

    trademarkCodes.each(function () {
      const checkbox = $(this);
      const id = checkbox.attr("name");

      if (checkbox.prop("checked")) {
        const listItem = step1MessageContainer
          .find(`li[data-id="${id}"]`)
          .first();

        listItem.addClass("selected bg-secondary text-white");
        listItem.css("pointer-events", "none");
        listItem.find("span.highlight").removeClass("highlight");
        listItem.find("span").css("color", "yellow");

        _sanitizeTrademarksArray();
      }
    });

    step1MessageContainer.find("li").each(function () {
      const listItem = $(this);
      const id = listItem.attr("data-id");

      if (selectedItems.includes(id)) {
        listItem.addClass("selected bg-secondary text-white");
        listItem.css("pointer-events", "none");
        listItem.find("span.highlight").removeClass("highlight");
        listItem.find("span").css("color", "yellow");

        _sanitizeTrademarksArray();
      }
    });
  }

  $(step1InputEem).on("keydown", function (event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      step1MessageContainer.empty();

      _sanitizeTrademarksArray();
    }
  });

  //* Event listener to hide autocomplete container when clicking outside of it
  $(document).on("click", function (event) {
    if (
      !step1MessageContainer.is(event.target) &&
      step1MessageContainer.has(event.target).length === 0
    ) {
      step1MessageContainer.hide();
      step1InputEem.val("");
      showAllTrademarks();

      _sanitizeTrademarksArray();
    }
  });

  //* Function to update the pill tab UI for multiple selections
  function updateCheckboxAndPillTab(id, label, isChecked) {
    const checkbox = $(`#trademarkList input[type=checkbox][name="${id}"]`);
    const correspondingCheckbox = $(
      `#trademarkCode input[type=checkbox][name="${id}"]`
    );

    if (isChecked) {
      const trademarkObj = { id, label };
      const trademarkIndex = accolade.trademarks.findIndex((x) => x.id === id);

      if (trademarkIndex === -1) {
        accolade.trademarks.push(trademarkObj);
        accolade.quantity += 1;
        _step1PillTabUI(step1SelectedElem, id, label);
      }
    } else {
      const trademarkIndex = accolade.trademarks.findIndex((x) => x.id === id);

      if (trademarkIndex !== -1) {
        accolade.trademarks.splice(trademarkIndex, 1);
        accolade.quantity -= 1;
        $(`p.badge[data-id="${id}"]`).remove();
      }
    }

    // Update the checkboxes
    checkbox.prop("checked", isChecked);
    correspondingCheckbox.prop("checked", isChecked);
  }
}

// Function to show all trademarks
function showAllTrademarks() {
  const trademarkList = $("#trademarkList");
  trademarkList.find("label").parent().show();
}

function resetStateWhenClickUncheckAll() {
  if (
    !step1MessageContainer.is(event.target) &&
    step1MessageContainer.has(event.target).length === 0
  ) {
    step1MessageContainer.hide();
    step1InputEem.val("");
    showAllTrademarks();

    selectedItems = [];
  }
}

function _getJsonData() {
  const getJsonData = $("#step1Json").text();

  try {
    const jsonData = JSON.parse(getJsonData);
    return jsonData.trademarks || [];
  } catch (error) {
    console.error(error);
    return [];
  }
}

function _sanitizeTrademarksArray() {
  //* Create a map to store unique items based on "id"
  const trademarks = accolade.trademarks;

  const uniqueDataMap = new Map();
  trademarks.forEach((tm) => {
    //* Split the "id" string using "_" as the delimiter and take the first part
    const idWithoutSuffix = tm.id.split("_")[0];

    accolade.quantity = accolade.trademarks.length;

    uniqueDataMap.set(idWithoutSuffix, tm);

    //* Convert the map values back to an array
    const uniqueData = Array.from(uniqueDataMap.values());

    accolade.trademarks = uniqueData;

    accolade.quantity = accolade.trademarks.length;

    //* Check corresponding checkbox
    const trademarkListCheckbox = $(
      `#trademarkList input[type=checkbox][name="${idWithoutSuffix}"]`
    );
    const trademarkCodeCheckbox = $(
      `#trademarkCode input[type=checkbox][name="${idWithoutSuffix}"]`
    );
    trademarkListCheckbox.prop("checked", true);
    trademarkCodeCheckbox.prop("checked", true);

    console.log("Sanitized First Stage: ", uniqueData);
  });
}

_step1SingleCheck();
_step1CheckAllAndUncheckAll();
_step1SearchFilter();

 

//* =-=-=-=-=-=-=-=-=-=-=-=-=-= End of Accolade Step 1 =-=-=-=-=-=-=-=-=-=-=-=-=-= *//
